import * as schema from "./generated/schema";
import { request } from "@/api";
type CarsMembersPath = schema.paths["/api/cars_members"];
type CarsMemberResponse =
  CarsMembersPath["get"]["responses"]["200"]["content"]["application/json"];
export type CarsMember = CarsMemberResponse["items"][number];

export const getCarsMembers = async () => {
  return await request.get<CarsMemberResponse>({ url: "/api/cars_members" });
};
